import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

export const useSidebarItems = () => {
  const { t } = useTranslation(['earnings']);

  const overviewRef = useRef<HTMLDivElement>(null);
  const earningsReactionRef = useRef<HTMLDivElement>(null);
  const metricsRef = useRef<HTMLDivElement>(null);
  const thematicToFocusRef = useRef<HTMLDivElement>(null);
  const keyItemsRef = useRef<HTMLDivElement>(null);
  const investmentOutlookRef = useRef<HTMLDivElement>(null);
  const relatedCompanyImplicationsRef = useRef<HTMLDivElement>(null);
  const recapOverviewRef = useRef<HTMLDivElement>(null);
  const marketReactionRef = useRef<HTMLDivElement>(null);
  const managementCommentaryRef = useRef<HTMLDivElement>(null);
  const thematicFocusRef = useRef<HTMLDivElement>(null);
  const relatedCompaniesImpactRef = useRef<HTMLDivElement>(null);
  const peerComparisonRef = useRef<HTMLDivElement>(null);
  const analystRef = useRef<HTMLDivElement>(null);

  const previewItems = [
    {
      id: 'overview',
      label: t('earningsInsight.drawer.earningsPreview.items.overview'),
      ref: overviewRef,
    },
    {
      id: 'earningsReaction',
      label: t('earningsInsight.drawer.earningsPreview.items.earningsReaction'),
      ref: earningsReactionRef,
    },
    {
      id: 'metrics',
      label: t('earningsInsight.drawer.earningsPreview.items.kpis'),
      ref: metricsRef,
    },
    {
      id: 'thematicToFocus',
      label: t('earningsInsight.drawer.earningsPreview.items.thematicToFocus'),
      ref: thematicToFocusRef,
    },
    {
      id: 'keyItems',
      label: t('earningsInsight.drawer.earningsPreview.items.keyItems'),
      ref: keyItemsRef,
    },
    {
      id: 'investmentOutlook',
      label: t(
        'earningsInsight.drawer.earningsPreview.items.investmentOutlook'
      ),
      ref: investmentOutlookRef,
    },
    {
      id: 'relatedCompanyImplications',
      label: t(
        'earningsInsight.drawer.earningsPreview.items.relatedCompanyImplications'
      ),
      ref: relatedCompanyImplicationsRef,
    },
  ];

  const recapItems = [
    {
      id: 'recapOverview',
      label: t('earningsInsight.drawer.earningsRecap.items.overview'),
      ref: recapOverviewRef,
    },
    {
      id: 'marketReaction',
      label: t('earningsInsight.drawer.earningsRecap.items.marketReaction'),
      ref: marketReactionRef,
    },
    {
      id: 'managementCommentary',
      label: t(
        'earningsInsight.drawer.earningsRecap.items.managementCommentary'
      ),
      ref: managementCommentaryRef,
    },
    {
      id: 'thematicFocus',
      label: t('earningsInsight.drawer.earningsRecap.items.thematicFocus'),
      ref: thematicFocusRef,
    },
    {
      id: 'relatedCompaniesImpact',
      label: t(
        'earningsInsight.drawer.earningsRecap.items.relatedCompaniesImpact'
      ),
      ref: relatedCompaniesImpactRef,
    },
    {
      id: 'peerComparison',
      label: t('earningsInsight.drawer.earningsRecap.items.peerComparison'),
      ref: peerComparisonRef,
    },
    {
      id: 'analystAndStreet',
      label: t('earningsInsight.drawer.earningsRecap.items.analystAndStreet'),
      ref: analystRef,
    },
  ];

  return { previewItems, recapItems };
};
